import { Component, OnInit, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'video-list-item',
  templateUrl: './video-list-item.component.html',
  styleUrls: ['./video-list-item.component.scss']
})
export class VideoListItemComponent implements OnInit {

  constructor(
    private element : ElementRef
  ) { }

  @Input() 
  public href : string;

  public get widthPx() {
    let el : HTMLElement = this.element.nativeElement;
    return el.offsetWidth;
  }

  public get offsetPx() {
    let el : HTMLElement = this.element.nativeElement;
    return el.offsetLeft;
  }

  ngOnInit() {
  }
}
